<!DOCTYPE html>

<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>Visualizador de PDF.</title>
  </head>
  <body>
    <div *ngIf="isPdf">
      <pdf-viewer
        [src]="fileSrc"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="false"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="false"
        style="width: 100%; height: 600px"
      ></pdf-viewer>
    </div>
    <div *ngIf="!isPdf">
      <img
        [src]="fileSrc"
        style="width: 100%; height: 600px"
        [zoom-scale]="'page-width'"
      />
    </div>
  </body>
</html>
